import React, { useEffect } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, CircularProgress, Checkbox, Divider, FormControl, FormControlLabel, Grid, Input, InputAdornment, Paper, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { useState, useRef, useMemo } from 'react';
import PersonIcon from '@mui/icons-material/Person';
import InputStyle from "../../../assets/InputStyle";
import flagIcon from "../../../images/flagIcon.png";
import { Select, MenuItem } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CloudUploadIcon from '../../../images/upload.svg';
import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { enqueueSnackbar } from "notistack";
import { useDispatch, useSelector } from "react-redux";
import { createProfile, uploadImages } from "../../../actions/userAuth";
import { GifBoxTwoTone } from "@mui/icons-material";

const Education = ({ setSelectedTab }) => {
    const [age, setAge] = React.useState('');
    const [coarseName, setCoarseName] = useState('');
    const [courseType, setCourseType] = useState('');
    const [specialization, setSpecialization] = useState('');
    const [degreeYears, setDegreeYears] = useState('');
    const [school, setSchool] = useState('');
    const [passingYear, setPassingYear] = useState('');
    const [percentageGrade, setPercentageGrade] = useState('');
    const [degreeImage, setDegreeImage] = useState("");

    const [courseNamePG, setCourseNamePg] = useState('');
    const [courseTypePg, setCourseTypePg] = useState('');
    const [specializationPg, setSpecializationPg] = useState('');
    const [degreeYearsPg, setDegreeYearsPg] = useState('');
    const [schoolPg, setSchoolPg] = useState('');
    const [passingYearPg, setPassingYearPg] = useState('');
    const [percentageGradePg, setPercentageGradePg] = useState('');
    const [degreeImagePg, setDegreeImagePg] = useState("");

    const [courseNameUg, setCourseNameUg] = useState('');
    const [courseTypeUg, setCourseTypeUg] = useState('');
    const [specializationUg, setSpecializationUg] = useState('');
    const [degreeYearsUg, setDegreeYearsUg] = useState('');
    const [schoolUg, setSchoolUg] = useState('');
    const [passingYearUg, setPassingYearUg] = useState('');
    const [percentageGradeUg, setPercentageGradeUg] = useState('');
    const [degreeImageUg, setDegreeImageUg] = useState("");

    const [classXIIType, setClassXIIType] = useState('');
    const [classXIISchool, setClassXIISchool] = useState('');
    const [classXIIPassingYear, setClassXIIPassingYear] = useState('');
    const [classXIIPercentageGrade, setClassXIIPercentageGrade] = useState('');
    const [classXIIImage, setClassXIIImage] = useState("");

    const [classXType, setClassXType] = useState('');
    const [classXSchool, setClassXSchool] = useState('');
    const [classXPassingYear, setClassXPassingYear] = useState('');
    const [classXPercentageGrade, setClassXPercentageGrade] = useState('');
    const [classXImage, setClassXImage] = useState("");
    const [additionalDegree, setAdditionalDegree] = useState([]);
    const [postGraduationDegree, setPostGraduationDegree] = useState([]);
    const [graduationDegree, setGraduationDegree] = useState([]);
    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();
    const { user } = useSelector((state) => ({ ...state }));
    useEffect(() => {
        if (user?.additionalDegrees?.length > 0) {
            setAdditionalDegree(user?.additionalDegrees);
        }
        if (user?.postGraduationDetails?.length > 0) {
            setPostGraduationDegree(user?.postGraduationDegree);
        }
        if (user?.graduationDetails?.length > 0) {
            setGraduationDegree(user?.graduationDetails);
        }
        setClassXIIImage(user?.classXII?.photo);
        setClassXIIPassingYear(user?.classXII?.passingYear);
        setClassXIIPercentageGrade(user?.classXII?.percentage);
        setClassXIISchool(user?.classXII?.schoolUniversity);
        setClassXIIType(user?.classXII?.courseType);
        setClassXImage(user?.classX?.photo);
        setClassXPassingYear(user?.classX?.passingYear);
        setClassXPercentageGrade(user?.classX?.percentage);
        setClassXSchool(user?.classX?.schoolUniversity);
    }, [user]);

    const handleChange = (event) => {
        setAge(event.target.value);
    };




    const handleAddAdditionalDegree = (event) => {
        // Prevent the Accordion from closing
        event.stopPropagation();
        if (!coarseName || !courseType || !specialization || !degreeYears || !school || !passingYear || !percentageGrade || !degreeImage) {

            enqueueSnackbar("Please fill all the necessary fields", { variant: 'warning' });
        }
        else if (isNaN(percentageGrade) || percentageGrade < 0 || percentageGrade > 100) {
            enqueueSnackbar("Please enter valid Degree percentage/grade", {
                variant: "error",
            });
        }

        else {
            let val = { courseName: coarseName, courseType: courseType, specialization: specialization, degreeDuration: parseInt(degreeYears), schoolUniversity: school, passingYear: parseInt(passingYear), percentage: parseFloat(percentageGrade), photo: degreeImage };
            setAdditionalDegree(oldArr => [...oldArr, val]);
        }

    };

    const handleAddPostGraduation = (event) => {
        // Prevent the Accordion from closing
        event.stopPropagation();

        if (!courseNamePG || !courseTypePg || !specializationPg || !degreeYearsPg || !schoolPg || !passingYearPg || !percentageGradePg || !degreeImagePg) {
            enqueueSnackbar("Please fill all the necessary fields", { variant: 'warning' });
        }
        else if (isNaN(percentageGradePg) || percentageGradePg < 0 || percentageGradePg > 100) {
            enqueueSnackbar("Please enter valid PG percentage/grade", {
                variant: "error",
            });
        }


        else {
            let val = { courseName: courseNamePG, courseType: courseTypePg, specialization: specializationPg, degreeDuration: parseInt(degreeYearsPg), schoolUniversity: schoolPg, passingYear: parseInt(passingYearPg), percentage: parseFloat(percentageGradePg), photo: degreeImagePg };
            console.log(val);
            setPostGraduationDegree(oldArr => [...oldArr, val]);
        }

    };

    const handleAddGraduation = (event) => {
        // Prevent the Accordion from closing
        event.stopPropagation();
        if (!courseNameUg || !courseTypeUg || !specializationUg || !degreeYearsUg || !schoolUg || !passingYearUg || !percentageGradeUg || !degreeImageUg) {
            enqueueSnackbar("Please fill all the necessary fields", { variant: 'warning' });
        }
        else if (isNaN(percentageGradeUg) || percentageGradeUg < 0 || percentageGradeUg > 100) {
            enqueueSnackbar("Please enter valid UG percentage/grade", {
                variant: "error",
            });
        }
        else {
            let val = { courseName: courseNameUg, courseType: courseTypeUg, specialization: specializationUg, degreeDuration: parseInt(degreeYearsUg), schoolUniversity: schoolUg, passingYear: parseInt(passingYearUg), percentage: parseFloat(percentageGradeUg), photo: degreeImageUg};
            console.log(val);
            setGraduationDegree(oldArr => [...oldArr, val]);
        }
    };


    const handleSubmit = () => {
        setLoading(true)
        let payload = {
            graduationDetails: graduationDegree,
            additionalDegrees: additionalDegree,
            postGraduationDetails: postGraduationDegree,
            classXII: {
                courseType: classXIIType,
                schoolUniversity: classXIISchool,
                passingYear: parseInt(classXIIPassingYear),
                percentage: parseFloat(classXIIPercentageGrade),
                photo: classXIIImage ? classXIIImage : ""
            },
            classX: {
                schoolUniversity: classXSchool,
                passingYear: parseInt(classXPassingYear),
                percentage: parseInt(classXPercentageGrade),
                photo: classXImage ? classXImage : ""
            }
        }

        console.log(classXImage);
        let user = JSON.parse(localStorage.getItem("user"));

        dispatch(createProfile(payload, user._id, user.role, (data) => {
            console.log(data)
            enqueueSnackbar("Education details added successfully", { variant: 'success' });
            setSelectedTab(2);
            setLoading(false)
        }, (err) => {
            enqueueSnackbar("Error Occured! please try again", { variant: 'error' });
            setLoading(false)

        }, localStorage.getItem("refreshToken")))
    }

    const currentYear = new Date().getFullYear();
    const last30Years = Array.from({ length: 30 }, (_, index) => currentYear - index);

    const handleYearChange1 = (event) => {
        setPassingYear(event.target.value);
    };

    const handleYearChange2 = (event) => {
        setPassingYearPg(event.target.value);
    };

    const handleYearChange3 = (event) => {
        setPassingYearUg(event.target.value);
    };


    const handleYearChange4 = (event) => {
        setClassXIIPassingYear(event.target.value);
    };

    const handleYearChange5 = (event) => {
        setClassXPassingYear(event.target.value);
    };

    const uploadImage = (e, setState) => {
        if (e.target.files[0].name.includes('jpg') || e.target.files[0].name.includes('png')) {
            let formData = new FormData();
            formData.append("file", e.target.files[0]);
            dispatch(uploadImages(formData, (data) => {
                setState(data.data.imagesKey[0]);
            }))
        } else {
            enqueueSnackbar("please upload a valid image", { variant: 'warning' });
        }
    }

    return (
        <>
            <Box py={3}>
                <Box sx={{ backgroundColor: '#F6F8F9', px: 5, py: 5, borderRadius: '4px', mx: { md: 5, xs: 1 } }}>
                    <Paper sx={{ mx: { md: 4, xs: 1 }, px: 5, pb: 5 }}>
                        <Box py={3} my={2}>
                            <Typography variant="h5" sx={{ fontWeight: 'bold' }}>Education</Typography>
                            <Divider sx={{ backgroundColor: '#e5e5e5', height: '1px', borderRadius: '2px', marginTop: '1rem' }} />
                        </Box>

                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Grid container>
                                    <Grid item md={10}>
                                        <Typography sx={{ color: '#000', fontWeight: '600' }}>
                                            Additional Degree
                                        </Typography>
                                    </Grid>
                                    <Grid item md={2}>
                                        <Button
                                            sx={{
                                                backgroundColor: '#2544EE',
                                                borderRadius: '5px',
                                                mx: 5,
                                                px: 5,
                                                float: 'right',
                                                '&:hover': {
                                                    backgroundColor: '#FFF',
                                                    color: '#2544EE',
                                                },
                                            }}
                                            variant="contained"
                                            onClick={handleAddAdditionalDegree}
                                        >
                                            <AddIcon /> Add
                                        </Button>
                                    </Grid>
                                </Grid>
                            </AccordionSummary>

                            <AccordionDetails sx={{}}>
                                <FormControl sx={{ display: 'block' }}>
                                    <Box>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={6}>
                                                <Typography component="label" className="input-heading">
                                                    Course Name
                                                </Typography>
                                                <Box >
                                                    <input
                                                        className="profile-skills-box mb-3"
                                                        value={coarseName}
                                                        onChange={(e) => setCoarseName(e.target.value)}
                                                        placeholder="Enter your Course Name"
                                                        required
                                                    />
                                                </Box>
                                            </Grid>

                                            <Grid item md={6}>
                                                <Typography component="label" className="input-heading">
                                                    Course Type
                                                </Typography>
                                                <Box >
                                                    <input
                                                        className="profile-skills-box mb-3"
                                                        value={courseType}
                                                        onChange={(e) => setCourseType(e.target.value)}
                                                        placeholder="Enter your Course Type"
                                                        required
                                                    />
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                                <Typography component="label" className="input-heading">
                                                    Specialization
                                                </Typography>
                                                <Box >
                                                    <input
                                                        className="profile-skills-box mb-3"
                                                        value={specialization}
                                                        onChange={(e) => setSpecialization(e.target.value)}
                                                        placeholder="Enter your Specialization"
                                                        required
                                                    />
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                                <Typography component="label" className="input-heading">
                                                    Number of Years of Degree
                                                </Typography>
                                                <Box >
                                                    <select
                                                        className="profile-skills-box mb-3"
                                                        value={degreeYears}
                                                        onChange={(e) => setDegreeYears(e.target.value)}
                                                        required
                                                    >
                                                        <option value="">Select</option>
                                                        <option value="1">1</option>
                                                        <option value="2">2</option>
                                                        <option value="3">3</option>
                                                        <option value="4">4</option>
                                                        <option value="5">5</option>
                                                        <option value="6">6</option>
                                                    </select>
                                                </Box>
                                            </Grid>

                                            <Grid item md={12}>
                                                <Typography component="label" className="input-heading">
                                                    School/University
                                                </Typography>
                                                <Box >
                                                    <input
                                                        className="profile-skills-box mb-3"
                                                        value={school}
                                                        onChange={(e) => setSchool(e.target.value)}
                                                        placeholder="Enter your school/university name"
                                                        required
                                                    />
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                                <Typography component="label" className="input-heading">
                                                    Passing Year
                                                </Typography>
                                                <Box >
                                                    <select

                                                        className="input-box mb-3"
                                                        value={passingYear}
                                                        onChange={handleYearChange1}
                                                    >
                                                        <option value="" disabled>
                                                            Select Year
                                                        </option>
                                                        {last30Years.map((year) => (
                                                            <option key={year} value={year}>
                                                                {year}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                                <Typography component="label" className="input-heading">
                                                    Percentage/Grade*
                                                </Typography>
                                                <Box >
                                                    <input
                                                        className="profile-skills-box mb-3"
                                                        value={percentageGrade}
                                                        onChange={(e) => setPercentageGrade(e.target.value)}
                                                        placeholder="Enter your percentage/grade"
                                                        required
                                                    />
                                                </Box>
                                            </Grid>

                                            <Grid item md={12}>
                                                <InputStyle name=" " topSpace={true} >
                                                    <Button
                                                        variant="outlined"
                                                        component="label"
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center',
                                                            border: ' 1px solid #D2D2D2',
                                                            borderRadius: '0.5rem',
                                                            py: 4,
                                                            flexDirection: 'column',
                                                        }}
                                                    >
                                                        <div
                                                            className="text2Mid"
                                                            style={{ color: '#000', opacity: '0.5' }}
                                                        >
                                                            {degreeImage
                                                                ?
                                                                <img src={degreeImage}
                                                                    alt="degree"
                                                                    style={{ width: "100%", height: '10rem' }}
                                                                />
                                                                :
                                                                <>
                                                                    <img src={CloudUploadIcon} sx={{ mx: 5 }} />
                                                                    Upload Picture
                                                                </>
                                                            }
                                                        </div>
                                                        <input type="file" hidden accept=".jpg,.png" onChange={(e) => uploadImage(e, setDegreeImage)} />
                                                    </Button>
                                                </InputStyle>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </FormControl>
                                {
                                    additionalDegree && additionalDegree.length > 0
                                        ?
                                        <Table>
                                            <TableHead>
                                                <TableCell>
                                                    Course Name
                                                </TableCell>
                                                <TableCell>
                                                    Course Type
                                                </TableCell>
                                                <TableCell>
                                                    Specialization
                                                </TableCell>
                                                <TableCell>

                                                    Number of Years of Degree
                                                </TableCell>
                                                <TableCell>
                                                    School/University
                                                </TableCell>
                                                <TableCell>
                                                    Passing Year
                                                </TableCell>
                                                <TableCell>
                                                    Percentage/Grade
                                                </TableCell>
                                                <TableCell>
                                                    Image
                                                </TableCell>
                                            </TableHead>
                                            <TableBody>
                                                {additionalDegree.map((item, index) => (
                                                    <>
                                                        {/* courseType, specialization, degreeYears, school, passingYear, percentageGrade, degreeImage */}
                                                        <TableRow key={index}>
                                                            <TableCell>
                                                                {item.courseName}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item.courseType}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item.specialization}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item.degreeDuration}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item.schoolUniversity}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item.passingYear}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item.percentage}
                                                            </TableCell>
                                                            <TableCell>
                                                                <img
                                                                    src={item.photo}
                                                                    alt="degree"
                                                                    style={{ width: '90px' }}
                                                                />
                                                            </TableCell>
                                                        </TableRow>
                                                    </>
                                                ))}
                                            </TableBody>
                                        </Table>
                                        :
                                        ""
                                }

                            </AccordionDetails>
                        </Accordion>
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Grid container>
                                    <Grid item md={10}>
                                        <Typography sx={{ color: '#000', fontWeight: '600' }}>
                                            Add Post Graduation Details
                                        </Typography>
                                    </Grid>
                                    <Grid item md={2}>
                                        <Button
                                            sx={{
                                                backgroundColor: '#2544EE',
                                                borderRadius: '5px',
                                                mx: 5,
                                                px: 5,
                                                float: 'right',
                                                '&:hover': {
                                                    backgroundColor: '#FFF',
                                                    color: '#2544EE',
                                                },
                                            }}
                                            variant="contained"
                                            onClick={handleAddPostGraduation}
                                        >
                                            <AddIcon /> Add
                                        </Button>
                                    </Grid>
                                </Grid>
                            </AccordionSummary>

                            <AccordionDetails sx={{}}>
                                <FormControl sx={{ display: 'block' }}>
                                    <Box>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={6}>
                                                <Typography component="label" className="input-heading">
                                                    Course Name
                                                </Typography>
                                                <Box >
                                                    <input
                                                        className="profile-skills-box mb-3"
                                                        value={courseNamePG}
                                                        onChange={(e) => setCourseNamePg(e.target.value)}
                                                        placeholder="Enter your Course Name"
                                                        required
                                                    />
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                                <Typography component="label" className="input-heading">
                                                    Course Type
                                                </Typography>
                                                <Box >
                                                    <input
                                                        className="profile-skills-box mb-3"
                                                        value={courseTypePg}
                                                        onChange={(e) => setCourseTypePg(e.target.value)}
                                                        placeholder="Enter your Course Type"
                                                        required
                                                    />
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                                <Typography component="label" className="input-heading">
                                                    Specialization
                                                </Typography>
                                                <Box >
                                                    <input
                                                        className="profile-skills-box mb-3"
                                                        value={specializationPg}
                                                        onChange={(e) => setSpecializationPg(e.target.value)}
                                                        placeholder="Enter your Specialization"
                                                        required
                                                    />
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                                <Typography component="label" className="input-heading">
                                                    Number of Years of Degree
                                                </Typography>
                                                <Box >
                                                    <select
                                                        className="profile-skills-box mb-3"
                                                        value={degreeYearsPg}
                                                        onChange={(e) => setDegreeYearsPg(e.target.value)}
                                                        required
                                                    >
                                                        <option value="">Select</option>
                                                        <option value="1">1</option>
                                                        <option value="2">2</option>
                                                        <option value="3">3</option>
                                                        <option value="4">4</option>
                                                        <option value="5">5</option>
                                                        <option value="6">6</option>
                                                    </select>
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} md={12}>
                                                <Typography component="label" className="input-heading">
                                                    School/University
                                                </Typography>
                                                <Box >
                                                    <input
                                                        className="profile-skills-box mb-3"
                                                        value={schoolPg}
                                                        onChange={(e) => setSchoolPg(e.target.value)}
                                                        placeholder="Enter your school/university name"
                                                        required
                                                    />
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                                <Typography component="label" className="input-heading">
                                                    Passing Year
                                                </Typography>
                                                <Box >
                                                    <select

                                                        className="input-box mb-3"
                                                        value={passingYearPg}
                                                        onChange={handleYearChange2}
                                                    >
                                                        <option value="" disabled>
                                                            Select Year
                                                        </option>
                                                        {last30Years.map((year) => (
                                                            <option key={year} value={year}>
                                                                {year}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                                <Typography component="label" className="input-heading">
                                                    Percentage/Grade
                                                </Typography>
                                                <Box >
                                                    <input
                                                        className="profile-skills-box mb-3"
                                                        onChange={(e) => setPercentageGradePg(e.target.value)}
                                                        placeholder="Enter your percentage/grade"
                                                        required
                                                    />
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} md={12} >
                                                <InputStyle name=" " topSpace={true}>
                                                    <Button
                                                        variant="outlined"
                                                        component="label"
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center',
                                                            border: ' 1px solid #D2D2D2',
                                                            borderRadius: '0.5rem',
                                                            py: 4,
                                                            flexDirection: 'column',
                                                        }}
                                                    >
                                                        {degreeImagePg
                                                            ?
                                                            <img src={degreeImagePg}
                                                                alt="degree"
                                                                style={{ width: "100%", height: '10rem', objectFit: 'contain' }}
                                                            />
                                                            :
                                                            <>
                                                                <img src={CloudUploadIcon} sx={{ mx: 5 }} />
                                                                <div
                                                                    className="text2Mid"
                                                                    style={{ color: '#000', opacity: '0.5' }}
                                                                >
                                                                    Upload Picture
                                                                </div>
                                                            </>}
                                                        <input type="file" hidden
                                                            images={".jpg, .png"}
                                                            onChange={(e) => uploadImage(e, setDegreeImagePg)} />
                                                    </Button>
                                                </InputStyle>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </FormControl>
                                {
                                    postGraduationDegree && postGraduationDegree.length > 0
                                        ?
                                        <Table>
                                            <TableHead>
                                                <TableCell>
                                                    Course Name
                                                </TableCell>
                                                <TableCell>
                                                    Course Type
                                                </TableCell>
                                                <TableCell>
                                                    Specialization
                                                </TableCell>
                                                <TableCell>

                                                    Number of Years of Degree
                                                </TableCell>
                                                <TableCell>
                                                    School/University
                                                </TableCell>
                                                <TableCell>
                                                    Passing Year
                                                </TableCell>
                                                <TableCell>
                                                    Percentage/Grade
                                                </TableCell>
                                                <TableCell>
                                                    Image
                                                </TableCell>
                                            </TableHead>
                                            <TableBody>
                                                {postGraduationDegree.map((item, index) => (
                                                    <>
                                                        {/* courseType, specialization, degreeYears, school, passingYear, percentageGrade, degreeImage */}
                                                        <TableRow key={index}>
                                                            <TableCell>
                                                                {item.courseName}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item.courseType}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item.specialization}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item.degreeDuration}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item.schoolUniversity}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item.passingYear}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item.percentage}
                                                            </TableCell>
                                                            <TableCell>
                                                                <img
                                                                    src={item.photo}
                                                                    alt="degree"
                                                                    style={{ width: '90px' }}
                                                                />
                                                            </TableCell>
                                                        </TableRow>
                                                    </>
                                                ))}
                                            </TableBody>
                                        </Table>
                                        :
                                        ""
                                }
                            </AccordionDetails>
                        </Accordion>
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Grid container>
                                    <Grid item md={10}>
                                        <Typography sx={{ color: '#000', fontWeight: '600' }}>
                                            Add  Graduation Details
                                        </Typography>
                                    </Grid>
                                    <Grid item md={2}>
                                        <Button
                                            sx={{
                                                backgroundColor: '#2544EE',
                                                borderRadius: '5px',
                                                mx: 5,
                                                px: 5,
                                                float: 'right',
                                                '&:hover': {
                                                    backgroundColor: '#FFF',
                                                    color: '#2544EE',
                                                },
                                            }}
                                            variant="contained"
                                            onClick={handleAddGraduation}
                                        >
                                            <AddIcon /> Add
                                        </Button>
                                    </Grid>
                                </Grid>
                            </AccordionSummary>

                            <AccordionDetails sx={{}}>
                                <FormControl sx={{ display: 'block' }}>
                                    <Box>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={6}>
                                                <Typography component="label" className="input-heading">
                                                    Course Name
                                                </Typography>
                                                <Box >
                                                    <input
                                                        className="profile-skills-box mb-3"
                                                        value={courseNameUg}
                                                        onChange={(e) => setCourseNameUg(e.target.value)}
                                                        placeholder="Enter your Course Name"
                                                        required
                                                    />
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                                <Typography component="label" className="input-heading">
                                                    Course Type
                                                </Typography>
                                                <Box >
                                                    <input
                                                        className="profile-skills-box mb-3"
                                                        value={courseTypeUg}
                                                        onChange={(e) => setCourseTypeUg(e.target.value)}
                                                        placeholder="Enter your Course Type"
                                                        required
                                                    />
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                                <Typography component="label" className="input-heading">
                                                    Specialization
                                                </Typography>
                                                <Box >
                                                    <input
                                                        className="profile-skills-box mb-3"
                                                        value={specializationUg}
                                                        onChange={(e) => setSpecializationUg(e.target.value)}
                                                        placeholder="Enter your Specialization"
                                                        required
                                                    />
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                                <Typography component="label" className="input-heading">
                                                    Number of Years of Degree
                                                </Typography>
                                                <Box >
                                                    <select
                                                        className="profile-skills-box mb-3"
                                                        value={degreeYearsUg}
                                                        onChange={(e) => setDegreeYearsUg(e.target.value)}
                                                        required
                                                    >
                                                        <option value="">Select</option>
                                                        <option value="1">1</option>
                                                        <option value="2">2</option>
                                                        <option value="3">3</option>
                                                        <option value="4">4</option>
                                                        <option value="5">5</option>
                                                        <option value="6">6</option>
                                                    </select>
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} md={12}>
                                                <Typography component="label" className="input-heading">
                                                    School/University
                                                </Typography>
                                                <Box>
                                                    <input
                                                        className="profile-skills-box mb-3"
                                                        value={schoolUg}
                                                        onChange={(e) => setSchoolUg(e.target.value)}
                                                        placeholder="Enter your school/university name"
                                                        required
                                                    />
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                                <Typography component="label" className="input-heading">
                                                    Passing Year
                                                </Typography>
                                                <Box >
                                                    <select

                                                        className="input-box mb-3"
                                                        value={passingYearUg}
                                                        onChange={handleYearChange3}
                                                    >
                                                        <option value="" disabled>
                                                            Select Year
                                                        </option>
                                                        {last30Years.map((year) => (
                                                            <option key={year} value={year}>
                                                                {year}
                                                            </option>
                                                        ))}
                                                    </select>

                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                                <Typography component="label" className="input-heading">
                                                    Percentage/Grade*
                                                </Typography>
                                                <Box >
                                                    <input
                                                        value={percentageGradeUg}
                                                        className="profile-skills-box mb-3"
                                                        onChange={(e) => setPercentageGradeUg(e.target.value)}
                                                        placeholder="Enter your percentage/grade"
                                                        required
                                                    />
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} md={12} >
                                                <InputStyle name=" " topSpace={true}>
                                                    <Button
                                                        variant="outlined"
                                                        component="label"
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center',
                                                            border: ' 1px solid #D2D2D2',
                                                            borderRadius: '0.5rem',
                                                            py: 4,
                                                            flexDirection: 'column',
                                                        }}
                                                    >
                                                        {degreeImageUg
                                                            ?
                                                            <img src={degreeImageUg}
                                                                alt="degree"
                                                                style={{ width: "100%", height: '10rem', objectFit: 'contain' }}
                                                            />
                                                            :
                                                            <>
                                                                <img src={CloudUploadIcon} sx={{ mx: 5 }} />
                                                                <div
                                                                    className="text2Mid"
                                                                    style={{ color: '#000', opacity: '0.5' }}
                                                                >
                                                                    Upload Picture
                                                                </div>
                                                            </>}
                                                        <input type="file" hidden
                                                            images={".jpg, .png"}
                                                            onChange={(e) => uploadImage(e, setDegreeImageUg)} />
                                                    </Button>
                                                </InputStyle>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </FormControl>
                                {
                                    graduationDegree && graduationDegree.length > 0
                                        ?
                                        <Table>
                                            <TableHead>
                                                <TableCell>
                                                    Course Name
                                                </TableCell>
                                                <TableCell>
                                                    Course Type
                                                </TableCell>
                                                <TableCell>
                                                    Specialization
                                                </TableCell>
                                                <TableCell>

                                                    Number of Years of Degree
                                                </TableCell>
                                                <TableCell>
                                                    School/University
                                                </TableCell>
                                                <TableCell>
                                                    Passing Year
                                                </TableCell>
                                                <TableCell>
                                                    Percentage/Grade
                                                </TableCell>
                                                <TableCell>
                                                    Image
                                                </TableCell>
                                            </TableHead>
                                            <TableBody>
                                                {graduationDegree.map((item, index) => (
                                                    <>
                                                        {/* courseType, specialization, degreeYears, school, passingYear, percentageGrade, degreeImage */}
                                                        <TableRow key={index}>
                                                            <TableCell>
                                                                {item.courseName}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item.courseType}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item.specialization}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item.degreeDuration}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item.schoolUniversity}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item.passingYear}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item.percentage}
                                                            </TableCell>
                                                            <TableCell>
                                                                <img
                                                                    src={item.photo}
                                                                    alt="degree"
                                                                    style={{ width: '90px' }}
                                                                />
                                                            </TableCell>
                                                        </TableRow>
                                                    </>
                                                ))}
                                            </TableBody>
                                        </Table>
                                        :
                                        ""
                                }
                            </AccordionDetails>
                        </Accordion>


                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Grid container>
                                    <Grid item md={10}>
                                        <Typography sx={{ color: '#000', fontWeight: '600' }}>
                                            Add Class XII Details
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </AccordionSummary>

                            <AccordionDetails sx={{}}>
                                <FormControl sx={{ display: 'block' }}>
                                    <Box>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={6}>
                                                <Typography component="label" className="input-heading">
                                                    Course Type
                                                </Typography>
                                                <Box >
                                                    <input
                                                        className="profile-skills-box mb-3"
                                                        value={classXIIType}
                                                        onChange={(e) => setClassXIIType(e.target.value)}
                                                        placeholder="Enter your Course Type"
                                                        required
                                                    />
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                                <Typography component="label" className="input-heading">
                                                    School/University
                                                </Typography>
                                                <Box >
                                                    <input
                                                        className="profile-skills-box mb-3"
                                                        value={classXIISchool}
                                                        onChange={(e) => setClassXIISchool(e.target.value)}
                                                        placeholder="Enter your school/university name"
                                                        required
                                                    />
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                                <Typography component="label" className="input-heading">
                                                    Passing Year
                                                </Typography>
                                                <Box >
                                                    <select

                                                        className="input-box mb-3"
                                                        value={classXIIPassingYear}
                                                        onChange={handleYearChange4}
                                                    >
                                                        <option >
                                                            Select
                                                        </option>
                                                        {last30Years.map((year) => (
                                                            <option key={year} value={year}>
                                                                {year}
                                                            </option>
                                                        ))}
                                                    </select>

                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                                <Typography component="label" className="input-heading">
                                                    Percentage/Grade*
                                                </Typography>
                                                <Box >
                                                    <input
                                                        className="profile-skills-box mb-3"
                                                        value={classXIIPercentageGrade}
                                                        onChange={(e) =>
                                                            setClassXIIPercentageGrade(e.target.value)
                                                        }
                                                        placeholder="Enter your percentage/grade"
                                                        required
                                                    />
                                                </Box>
                                            </Grid>

                                            <Grid item md={12} sx={{}}>
                                                <InputStyle name=" " topSpace={true}>
                                                    <Button
                                                        variant="outlined"
                                                        component="label"
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center',
                                                            border: '1px solid #D2D2D2',
                                                            borderRadius: '0.5rem',
                                                            py: 4,
                                                            flexDirection: 'column',
                                                        }}
                                                    >
                                                        {
                                                            classXIIImage
                                                                ?
                                                                <img src={classXIIImage}
                                                                    alt="degree"
                                                                    style={{ width: "100%", height: '10rem', objectFit: 'contain' }}
                                                                />
                                                                :
                                                                <>
                                                                    <img src={CloudUploadIcon} sx={{ mx: 5 }} />
                                                                    <div
                                                                        className="text2Mid"
                                                                        style={{ color: '#000', opacity: '0.5' }}
                                                                    >
                                                                        Upload Picture
                                                                    </div>
                                                                </>
                                                        }

                                                        <input type="file" hidden
                                                            onChange={(e) => uploadImage(e, setClassXIIImage)} />
                                                    </Button>
                                                </InputStyle>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </FormControl>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Grid container>
                                    <Grid item md={10}>
                                        <Typography sx={{ color: '#000', fontWeight: '600' }}>
                                            Add Class X Details*
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </AccordionSummary>

                            <AccordionDetails sx={{}}>
                                <FormControl sx={{ display: 'block' }}>
                                    <Box>
                                        <Grid container spacing={2}>
                                            <Grid item md={12}>
                                                <Typography
                                                    component="label"
                                                    className="input-heading"
                                                >
                                                    School/University
                                                </Typography>
                                                <Box >
                                                    <input
                                                        className="profile-skills-box mb-3"
                                                        value={classXSchool}
                                                        onChange={(e) => setClassXSchool(e.target.value)}
                                                        placeholder="Enter your school/university name"
                                                        required
                                                    />
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                                <Typography
                                                    component="label"
                                                    className="input-heading"
                                                >
                                                    Passing Year
                                                </Typography>
                                                <Box >
                                                    <select

                                                        className="input-box mb-3"
                                                        value={classXPassingYear}
                                                        onChange={handleYearChange5}
                                                    >
                                                        <option value="" disabled>
                                                            Select Year
                                                        </option>
                                                        {last30Years.map((year) => (
                                                            <option key={year} value={year}>
                                                                {year}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                                <Typography
                                                    component="label"
                                                    className="input-heading"
                                                >
                                                    Percentage/Grade*
                                                </Typography>
                                                <Box >
                                                    <input
                                                        className="profile-skills-box mb-3"
                                                        value={classXPercentageGrade}
                                                        onChange={(e) =>
                                                            setClassXPercentageGrade(e.target.value)
                                                        }
                                                        placeholder="Enter your percentage/grade"
                                                        required
                                                    />
                                                </Box>
                                            </Grid>

                                            <Grid item md={12} sx={{}}>
                                                <InputStyle name=" " topSpace={true}>
                                                    <Button
                                                        variant="outlined"
                                                        component="label"
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center',
                                                            border: '1px solid #D2D2D2',
                                                            borderRadius: '0.5rem',
                                                            py: 4,
                                                            flexDirection: 'column',
                                                        }}
                                                    >
                                                        {
                                                            classXImage
                                                                ?
                                                                <img src={classXImage}
                                                                    alt="degree"
                                                                    style={{ width: "100%", height: '10rem', objectFit: 'contain' }}
                                                                />
                                                                :
                                                                <>
                                                                    <img src={CloudUploadIcon} sx={{ mx: 5 }} />
                                                                    <div
                                                                        className="text2Mid"
                                                                        style={{ color: '#000', opacity: '0.5' }}
                                                                    >
                                                                        Upload Picture
                                                                    </div>
                                                                </>
                                                        }
                                                        <input type="file" hidden
                                                            onChange={(e) => uploadImage(e, setClassXImage)} />
                                                    </Button>
                                                </InputStyle>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </FormControl>
                            </AccordionDetails>
                        </Accordion>

                        <Box my={3}>
                            <Button sx={{
                                backgroundColor: '#2544EE',
                                borderRadius: '2rem',
                                px: 5,
                                '&:hover': {
                                    backgroundColor: '#FFF',
                                    color: '#2544EE',
                                },
                            }}
                                variant="contained"
                                onClick={handleSubmit}
                                disabled={loading}>
                                {
                                    loading
                                        ?
                                        <CircularProgress size={24} />
                                        :
                                        "Save"
                                }
                            </Button>


                            <Button mx={5} sx={{
                                mx: '5',
                                color: '#2544EE',
                                backgroundColor: '#FFf',
                                border: '1px solid #2544EE',
                                borderRadius: '2rem',
                                mx: 5,
                                px: 5,
                                '&:hover': {
                                    backgroundColor: '#FFF',
                                    color: '#2544EE',
                                },
                            }}
                                variant="contained"
                            >
                                cancel
                            </Button>
                        </Box>
                    </Paper>
                </Box>
            </Box >
        </>
    );
}

export default Education;
